//@ts-nocheck
import { useEffect } from 'react';
import { observer } from 'mobx-react';

import { Checkbox, Input } from '@gamesb42/ui-kit';
import { appInfoInst } from '.';
import s from './styles.module.scss';

// Типы для монетизации
type MonetizationOption =
  | 'In-app purchase'
  | 'Ads'
  | 'In-app purchase & Ads'
  | 'Premium'
  | 'Subscription'
  | "I don't know"
  | 'Other';

// Список опций монетизации
const MONETIZATION_OPTIONS: MonetizationOption[] = [
  'In-app purchase',
  'Ads',
  'In-app purchase & Ads',
  'Premium',
  'Subscription',
  "I don't know",
  'Other',
];

// Переиспользуемый компонент для опции монетизации
const MonetizationOptionComponent = observer(
  ({
    option,
    checked,
    onToggle,
  }: {
    option: MonetizationOption;
    checked: boolean;
    onToggle: (option: MonetizationOption, checked: boolean) => void;
  }) => (
    <Checkbox
      checked={checked}
      onChange={(e) => onToggle(option, e.target.checked)}
    >
      {option}
    </Checkbox>
  ),
);

const Step2 = observer(() => {
  useEffect(() => {
    const hasMonetization = appInfoInst.values.monetization.length > 0;
    const hasOther = appInfoInst.values.monetization.includes('Other');
    const hasOtherComment =
      appInfoInst.values.otherMonetizationComment?.trim().length > 0;

    // Валидация: должна быть выбрана хотя бы одна опция
    // И если выбран "Other", должен быть заполнен комментарий
    appInfoInst.isStepIsValid[2] =
      hasMonetization && (!hasOther || hasOtherComment);
  }, [
    appInfoInst.values.monetization,
    appInfoInst.values.otherMonetizationComment,
  ]);

  // Функция для переключения опции монетизации
  const toggleMonetizationOption = (
    option: MonetizationOption,
    checked: boolean,
  ) => {
    if (checked) {
      appInfoInst.values.monetization = [
        ...appInfoInst.values.monetization,
        option,
      ];
    } else {
      appInfoInst.values.monetization = appInfoInst.values.monetization.filter(
        (el) => el !== option,
      );
      // Очищаем комментарий, если снята галочка с "Other"
      if (option === 'Other') {
        appInfoInst.values.otherMonetizationComment = '';
      }
    }
  };

  return (
    <>
      <h3>
        <b>Monetization model of your app/game?*</b>
      </h3>

      <div className={s.checkboxes}>
        {MONETIZATION_OPTIONS.map((option) => (
          <MonetizationOptionComponent
            key={option}
            option={option}
            checked={appInfoInst.values.monetization.includes(option)}
            onToggle={toggleMonetizationOption}
          />
        ))}
      </div>

      {/* Поле для "Other" - теперь работает */}
      {appInfoInst.values.monetization.includes('Other') && (
        <div style={{ marginTop: '32px' }}>
          <Input
            size="large"
            label="Enter your monetization model*"
            value={appInfoInst.values.otherMonetizationComment || ''}
            onChange={(e) => {
              appInfoInst.values.otherMonetizationComment = e.target.value;
            }}
            status={
              !appInfoInst.values.otherMonetizationComment?.trim()
                ? 'error'
                : undefined
            }
          />
          {!appInfoInst.values.otherMonetizationComment?.trim() && (
            <div className={s.errorMessage}>This field is required</div>
          )}
        </div>
      )}
    </>
  );
});

export default Step2;
